module.exports = __webpack_public_path__ + "static/media/apple-brands.8f00b25b.svg";